/**
 * Возвращает название файла без расширения
 * @param name Название файла расширением
 * @returns Название файла без расширения или пустая строка
 */

export const getFileNameWithoutExtention = (name?: string) => {
  return name?.replace(/\.[^/.]+$/, "") || "";
};
